export default __webpack_public_path__ + "static/about-heim-08a6d2505fc0e636ab41b76f3f73141b.png";